import { useState, useEffect, useCallback, useRef } from 'react';
import { Button } from 'rsuite';
import { EXAMINATION_VIDEO_BASE_URL, IMAGE_BASE_URL, postSaveDiagnosis } from '../../../core';
import TurnBackIcon from '../../../assets/icons/turn_back.svg';
// import { CustomLoader } from './../../../components/basic/loader';
import { useNavigate } from 'react-router-dom';
import { CustomLoader } from '../../../components/basic/loader';
import { showToast } from '../../../utils/toast';
// import { showToast } from '../../../utils/toast';
import ReactPlayer from 'react-player';
import { useDiagnosis } from '../../../contexts/diagnosis';
interface VertexModel {
  questionLabel: string;
  vertexId: number;
  question_explain_text: string;
  question_explain_voice_address: string | null;
  question_explain_image: string | null;
}
export const DecisionTree = (props: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: { vertices: any[]; edges: any[] } | any;
  productId: number;
  invoiceId: number;
  refNumber: string;
  viewMode?: boolean;
}) => {
  const navigate = useNavigate();
  const { setShowModal } = useDiagnosis();
  const [playingAudio, setPlayingAudio] = useState('');
  const [vertices, setVertices] = useState(props.data?.vertices);
  const [edges, setEdges] = useState(props.data?.edges);
  const [log, setLog] = useState<VertexModel[]>([]);
  const [answersLog, setAnswersLog] = useState<string[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [pathOfEdges, setPathOfEdges] = useState<any[]>([]);
  const [currentVertexId, setCurrentVertexId] = useState(-1);
  const [fakeLoading, setFakeLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const chatParent = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.viewMode) {
      console.log(props.data);
      if (props.data?.path_of_diagnosis_edges && props.data?.path_of_diagnosis_vertices) {
        const tempAnswersLog: string[] = [];
        setPathOfEdges(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          JSON.parse(props.data.path_of_diagnosis_edges).map((item: any, index: number) => {
            const parsed = JSON.parse(item);
            tempAnswersLog[index] = parsed.edgeLabel;
            return parsed;
          })
        );

        setAnswersLog(tempAnswersLog);
        setLog(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          JSON.parse(props.data.path_of_diagnosis_vertices).map((item: any) => JSON.parse(item))
        );
      }
      setShowModal(false);
      setIsDone(true);
      return;
    }
    setEdges(props.data.edges);
    setVertices(props.data.vertices);
    setLog([props.data.vertices[0]]);
    setAnswersLog([]);
    setCurrentVertexId(-1);
    setIsDone(false);
    // console.log(props.data.edges[0]);
  }, [props.data?.edges, props.data?.vertices, props?.viewMode, props.data]);

  const getEdgeById = useCallback(
    (vertexId: number) => {
      if (isDone) return [];
      if (vertexId === -1) return edges[0];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filtered = edges.filter((item: any) => {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        if (item[0]?.fromVertex?.vertexId === vertexId) {
          console.log(item, vertexId);
          return true;
        }
        return false;
      });
      console.log(filtered[0]);
      if (filtered[0]) {
        return filtered[0];
      } else {
        console.log('done done');
        setShowModal(false);
        setIsDone(true);
        return [];
      }
    },
    [edges, isDone]
  );
  const handleMoveToNextVertex = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (nextVertexId: number, toVertex: VertexModel, clickedLabel: string, edge: any) => {
      // console.log('toVertex', toVertex);
      // console.log('nextVertexId', nextVertexId);
      setFakeLoading(true);
      setPlayingAudio('');
      setTimeout(() => {
        setCurrentVertexId(nextVertexId);
        // const vertex = getVertexById(nextVertexId);
        setLog((prev) => [...prev, toVertex]);
        setAnswersLog((prev) => [...prev, clickedLabel]);
        setPathOfEdges((prev) => [...prev, edge]);
        setFakeLoading(false);
      }, 500);
    },
    [currentVertexId, vertices]
  );
  const handleMoveToPevVertex = useCallback(() => {
    const last = log[log.length - 2].vertexId;
    setCurrentVertexId(last);
    setAnswersLog((prev) => prev.slice(0, -1));
    setPathOfEdges((prev) => prev.slice(0, -1));
    setLog((prev) => prev.slice(0, -1));
  }, [log]);

  useEffect(() => {
    const domNode = chatParent.current;
    if (domNode) {
      domNode.scroll({ top: domNode.scrollHeight + 200, behavior: 'smooth' });
      // domNode.scrollTop = domNode.scrollHeight + 200;
    }
  }, [log]);
  // useEffect(() => {
  //   console.log(edges[currentVertexId]);
  // }, [currentVertexId]);

  const handleShowSuggested = useCallback(() => {
    // doctor_suggestion
    navigate(`/suggestions/${props.productId}/${log[log.length - 1].vertexId}/`);
  }, [props.productId, log]);

  useEffect(() => {
    if (props.viewMode) return;
    if (!isDone) return;
    console.log('will redirect to suggestion page');
    console.log(log);
    console.log(pathOfEdges);
    // todo: make jsons string
    const payload = {
      end_result_vertex: JSON.stringify(log[log.length - 1]),
      product_id: props.productId,
      // path_of_diagnosis_vertices: JSON.stringify(log).replaceAll('"', "'"),
      path_of_diagnosis_vertices: JSON.stringify(log.map((item) => JSON.stringify(item))),
      // path_of_diagnosis_edges: JSON.stringify(pathOfEdges).replaceAll('"', "'"),
      path_of_diagnosis_edges: JSON.stringify(pathOfEdges.map((item) => JSON.stringify(item))),
      invoice_id: props.invoiceId,
      ref_num: props.refNumber
    };
    // console.log(payload);
    (async () => {
      try {
        const { data, status } = await postSaveDiagnosis(payload);
        console.log(data);
        if (status) {
          showToast('با موفقیت ثبت شد!', 'success');
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [isDone, props.viewMode]);

  if (!props.viewMode && (!vertices.length || !edges.length)) {
    return <CustomLoader />;
  }

  return (
    <div className="h-[100%] bg-[#fff] pt-3">
      <div className={`${isDone ? 'h-[90%]' : 'h-[70%]'} overflow-auto px-3`} ref={chatParent}>
        {!isDone ? <p className="text-center mb-2">به سوالات با دقت و حوصله پاسخ دهید</p> : null}
        {log?.map((item, index) => {
          return (
            <div key={item.vertexId}>
              <div
                className="max-w-[95%] w-fit mr-auto bg-[#47e49a] p-3 text-[--rs-gray-800] text-justify mb-2"
                style={{ borderRadius: '20px 20px 20px 0' }}>
                {item.questionLabel}
              </div>
              {item.question_explain_text ? (
                <div
                  className="max-w-[95%] w-fit mr-auto bg-[#47e49a] p-3 text-[--rs-gray-800] text-justify mb-2"
                  style={{ borderRadius: '20px 20px 20px 0' }}>
                  {item.question_explain_text}
                </div>
              ) : null}
              {item.question_explain_voice_address ? (
                <ReactPlayer
                  className="max-w-[100%] custom-video mb-2"
                  url={`${EXAMINATION_VIDEO_BASE_URL}/${item.question_explain_voice_address}`}
                  controls
                  playing={item.question_explain_voice_address === playingAudio}
                  onPlay={() => {
                    setPlayingAudio(item.question_explain_voice_address ?? '');
                  }}
                  config={{
                    file: {
                      attributes: {
                        controlsList: 'nodownload'
                      }
                    }
                  }}
                />
              ) : null}
              {item.question_explain_image ? (
                <img
                  style={{ width: '100%', marginBottom: '8px' }}
                  src={`${IMAGE_BASE_URL}/${item.question_explain_image}`}
                />
              ) : null}
              {answersLog[index] ? (
                <div
                  className="max-w-[95%] w-fit ml-auto bg-[--rs-gray-400] p-3 text-[--rs-gray-100] text-justify mb-2"
                  style={{ borderRadius: '20px 20px 0 20px' }}>
                  {answersLog[index]}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
      {props.viewMode ? null : (
        <div className="max-h-[20%] px-3 flex flex-col items-center overflow-auto pt-2">
          {getEdgeById(currentVertexId)?.map(
            (edge: { edgeLabel: string; fromVertex: VertexModel; toVertex: VertexModel }) => {
              return (
                <Button
                  appearance="primary"
                  className="!mb-2 inline-block max-w-[100%] min-h-[48px]"
                  style={{ whiteSpace: 'pre-wrap' }}
                  key={edge.edgeLabel}
                  onClick={() => {
                    handleMoveToNextVertex(
                      edge.toVertex.vertexId,
                      edge.toVertex,
                      edge.edgeLabel,
                      edge
                    );
                  }}
                  loading={fakeLoading}>
                  {edge.edgeLabel}
                </Button>
              );
            }
          )}
        </div>
      )}
      <div className="px-3 flex flex-row-reverse">
        {currentVertexId > 0 && !isDone ? (
          <Button
            onClick={() => {
              setPlayingAudio('');
              handleMoveToPevVertex();
            }}
            // loading={fakeLoading}
            size="md"
            className="btn-outline">
            <img
              src={TurnBackIcon}
              className="ml-2 w-4"
              style={{ transform: 'rotateY(180deg)' }}
              alt=""
            />
            سوال قبل
          </Button>
        ) : null}
      </div>
      <div className="px-3 flex justify-center">
        {isDone ? (
          <Button appearance="primary" onClick={() => handleShowSuggested()} loading={fakeLoading}>
            پیشنهاد پزشک متخصص جهت ویزیت حضوری
          </Button>
        ) : null}
      </div>
    </div>
  );
};
